import React, { useState } from "react";
import Button from "../../base/buttons/Button";
import { CiSearch } from "react-icons/ci";
import Lists from "./Lists";
import Persona from "./Persona";
import Name from "./Name";
import Scores from "./Scores";
import Signals from "./Signals";

const Sidebar = () => {
  const [text, setText] = useState("");

  const handleSearch = (e) => {
    setText(e.target.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    // fire search action here
  };
  return (
    <aside className="w-full shadow-md border-y-1">
      <div className="md:flex h-14">
        <div className="flex text-sm font-medium">
          <Button children="Search" />
          <Button children="Saved searches" />
        </div>
      </div>
      <hr />
      <form onSubmit={handleSubmit} className="px-4 py-3 m-1 border-collapse">
        <div className="flex items-center text-gray-300">
          <CiSearch className="text-gray-500" />
          <input
            type="text"
            value={text}
            onChange={handleSearch}
            placeholder="Search People"
            className="px-2 focus:outline-none"
          />
        </div>
      </form>
      <hr />
      <div className="flex flex-row items-center h-14 p-3 justify-between">
        <div className="md:flex font-semibold">Filters</div>
        <button type="button" className="md:flex text-sm text-blue-500 font-sm">
          Save
        </button>
      </div>
      <hr />
      <div className="h-[18.5rem] overflow-y-auto">
        <div className="h-[18.5rem] overflow-y-auto">
          <Lists />
          <Persona />
          <Name />
          <Scores />
          <Signals />
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
